(function () {
  var myCart = setInterval(Carttimer, 500);
  function Carttimer() {
    if (window.$) {
      $(document).ready(function () {
        $(document).on("change", ".swell-product-list", function () {
          var variant_id = $(this).children("option:selected").data("variant-id");
          $(this).parent().parent().find(".swell-redemption-option-cost").hide();
          $("[data-variant-id='" + variant_id + "']").show();
        });

        $('body').on('click', ".swell-cart-dropdown .swell-redemption-option-cost", function () {
          $(document).on("swell:cart:updated", function () {
            if (window.location.href.indexOf("cart") > -1) {
              window.location = "/cart";
            }
          });
        });

        $(document).on("swell:setup", function () {
          initializeCartDropdown();
          if (spapi.authenticated && spapi.customer.vip_tier) {
            $(".swell-cart-redeem-section").css("display", "block");
            $(".swell-minicart-text").css("display", "block");
          }
        })
      });
      stopCart();
    }
  }
  function stopCart() {
    clearInterval(myCart);
  }
}).call(this);

function initializeCartDropdown() {
  var loggedIn1 = "";
  if (spapi.authenticated && spapi.customer.vip_tier) {
    loggedIn1 = "swell-buy-product-btn"
  }
  spapi.activeRedemptionOptions.forEach(function (redemption) {
    if (redemption.discount_type == "product") {
      var id = redemption.id;
      var background_image_url = redemption.background_image_url;
      var redemption_name = redemption.name;
      var cost_text = redemption.cost_text;
      var variant_id = redemption.applies_to_id;
      var redemption_icon = redemption.icon;

      $(".swell-product-list").append("<option data-variant-id=" + variant_id + ">" + redemption_name + "</option>");
      $(".swell-cart-dropdown").append("<div class='swell-redemption-option-cost " + loggedIn1 + "' data-error-content='Looks like you dont have enough points for this product. This product costs *|amount|* points and you only have *|point_balance|* points available.' data-variant-id='" + variant_id + "'  coupon_id='" + id + "' > <a class='redeem-btn' href='javascript:void(0)'>APPLY</a> </div>");
    }
  });
  $(".swell-product-list").prepend("<option selected data-variant-id='-1'>Choose your reward</option>");
  $(".swell-cart-dropdown").append("<div class='swell-redemption-option-cost' data-variant-id=-1> <a class='redeem-btn' href='javascript:void(0)'>APPLY</a> </div>");
  swellAPI.refreshEmbeds();
  $(".swell-product-list").trigger('change');
}
